import React from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import appPath from "utils/appPath";
import { countAdmins, isBulkAdmin } from "utils/bulkSubscriptionUtils";
import manageBulkSubscriptionActions from "ducks/manageBulkSubscription";
import ManageBulkSubscription from "components/v3/bulk-subscriptions/self-serve/manage/ManageBulkSubscription";
import { SCREENS } from "common/constants/Constants";
import { BULK_SUBSCRIPTION_USER_ROLES } from "common/constants/v2/Constants";

class ManageBulkSubscriptionContainer extends React.Component {
    componentDidMount() {
        this.props.checkSubscriptionStatus();
        this.props.getUsers();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.users !== this.props.users) {
            this.props.checkIfAdmin(this.props.userId, this.props.users);
        }
    }

    render() {
        return <ManageBulkSubscription { ...this.props } />;
    }
}

export function createMapStateToProps() {
    return (state) => {
        const {
            manageBulkSubscription: {
                id,
                name,
                maxUsersCount,
                email,
                users,
                errors,
                status,
                userActionState
            },
            manageSubscription: {
                endDate
            },
            user = {}
        } = state;

        return {
            userId: user.id,
            id,
            name,
            endDate,
            maxUsersCount,
            email,
            users,
            errors,
            status,
            userActionState,
            numberOfAdmins: countAdmins(users)
        };
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        getUsers() {
            dispatch(manageBulkSubscriptionActions.getUsers());
        },

        checkSubscriptionStatus() {
            dispatch(manageBulkSubscriptionActions.checkSubscriptionStatus());
        },

        onEmailChange(email) {
            dispatch(manageBulkSubscriptionActions.setAndValidateEmail(email));
        },

        onAddUser() {
            dispatch(manageBulkSubscriptionActions.addUser());
        },

        checkIfAdmin(userId, users) {
            if (!isBulkAdmin(userId, users)) {
                browserHistory.push(appPath(SCREENS.ACCOUNT));
            }
        },

        redirectToSubscriptions() {
            browserHistory.push(appPath(SCREENS.SUBSCRIPTIONS));
        },

        resetUserAction() {
            dispatch(manageBulkSubscriptionActions.userActionSuccess({}));
            dispatch(manageBulkSubscriptionActions.userActionError({}));
        },

        addAdmin(subscriberId) {
            dispatch(manageBulkSubscriptionActions.updateUserRole(subscriberId, BULK_SUBSCRIPTION_USER_ROLES.ADMIN));
        },

        removeAdmin(subscriberId) {
            dispatch(manageBulkSubscriptionActions.updateUserRole(subscriberId, BULK_SUBSCRIPTION_USER_ROLES.USER));
        },

        resendVerificationEmail(subscriberId) {
            dispatch(manageBulkSubscriptionActions.resendVerificationEmail(subscriberId));
        },

        removeUser(userId) {
            dispatch(manageBulkSubscriptionActions.removeUser(userId));
        }
    };
}

export default connect(
    createMapStateToProps(),
    mapDispatchToProps
)(ManageBulkSubscriptionContainer);
